import actions from '@/store/wizards/actions';

const wizardsModule = {
  state: () => ({
    productWizard: {},
    wizardSteps: [],
    isLoading: false,
    error: null,
  }),
  getters: {},
  mutations: {
    GET_WIZARD_START(state) {
      state.isLoading = true;
      state.error = null;
    },
    GET_WIZARD_SUCCESS(state, data) {
      state.productWizard = data;
      state.isLoading = false;
      state.error = null;
    },
    GET_WIZARD_FAILURE(state, data) {
      state.isLoading = false;
      state.error = data;
    },
    GET_WIZARD_STEPS_SUCCESS(state, data) {
      state.wizardSteps = data;
      state.isLoading = false;
      state.error = null;
    },
  },
  actions,
  namespaced: true,
};

export default wizardsModule;
